import Collapse from '@mui/material/Collapse';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import type { ReactElement } from 'react';

import { ConfigHistory } from './ConfigHistory';

/**
 * The collapse row under a config row hosting the lazy history (AUT-131).
 * Moved out of `ConfigRow` in AUT-542 to keep its render under the
 * function-line cap once the form row joined it.
 */
export interface ConfigHistoryRowProps {
  configKey: string;
  /** «Технический ключ: …» — the key spelled out for a developer. */
  keyHint: string;
  open: boolean;
}

export const ConfigHistoryRow = ({
  configKey,
  keyHint,
  open,
}: ConfigHistoryRowProps): ReactElement => (
  <TableRow>
    <TableCell colSpan={5} sx={{ py: 0, borderBottom: open ? undefined : 'none' }}>
      <Collapse in={open} unmountOnExit>
        {/*
          The one place the dotted key is spelled out in full text
          (AUT-284) — behind a deliberate expand, not in the row. This
          is what an operator reads out to a developer.
        */}
        <Typography
          variant="caption"
          component="div"
          color="text.secondary"
          sx={{ fontFamily: 'monospace', pt: 1 }}
        >
          {keyHint}
        </Typography>
        <ConfigHistory configKey={configKey} expanded={open} />
      </Collapse>
    </TableCell>
  </TableRow>
);
